import { AppSteps, Environment, Program, ProgramMode } from '../../../api/api.type';

export enum DividedEachPageState {
    FALSE,
    INACTIVE,
    TRUE
}

// export type UploadErrorMessage = "Zbyt duży rozmiar pliku. Maksymalny rozmiar to 10 MB." | "Plik ma nieodpowiedni format lub jest uszkodzony. Akceptowane formaty to .pdf, .jpg, .png, .gif, .bmp, .tiff." | "Akceptowane są tylko jednostronicowe pliki TIFF." | "Plik jest zabezpieczony hasłem (do otwarcia lub edycji)." | "Plik jest uszkodzony.";

export type UploadError = { filename: string; error: string };

export interface AppContext {
    dividedEachPage: DividedEachPageState;
    sessionId: string;
    appStep: AppSteps;
    errors: UploadError[];
    program?: Program;
    environment?: Environment;
    programMode?: ProgramMode;
    showTutorial?: boolean;
}
